<script>
export default {
  name: 'MenuItem',
  functional: true,
  props: {
    icon: {
      type: String,
      default: ''
    },
    fa: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    }
  },
  render (h, context) {
    const { icon, title, fa } = context.props
    // console.log(icon, title, fa)
    const vnodes = []

    if (icon) {
      const os = [fa, icon]
      vnodes.push(<i style="margin-right: 16px; color: rgb(191, 203, 217)" class={os} />)
    }

    if (title) {
      vnodes.push(<span slot='title'>{(title)}</span>)
    }
    return vnodes
  }
}
</script>
<style lang="scss">
.menu-wrapper {
  .el-menu-item.is-active i {
    color: rgb(64, 158, 255) !important;
  }
}
</style>
